const SurveyConstants = {
  button: {
    borderRadius: '3px',
  },
};

export default SurveyConstants;

// Card/Modal IDs - match ExitExperienceConstants.java
export const CANCEL_WITH_REFUND_MODAL_ID = 'cancel_with_refund';

// Event property field names - match ExitExperienceConstants.java
export const REFUND_ELIGIBLE = 'refund_eligible';
export const MUST_CANCEL_BY = 'must_cancel_by';

// MethodOfCancel enum - match MethodOfCancel.java
export enum MethodOfCancel {
  IMMEDIATE = 'IMMEDIATE',
  END_OF_TERM = 'END_OF_TERM',
}
